import React from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { usePublicTheme } from "@/contexts/ThemeContext";

export const PublicLayout = ({ children }) => {
  const { theme } = usePublicTheme();
  return (
    <div
      data-testid="public-root"
      data-theme={theme}
      className={`${theme === "dark" ? "coh-dark" : ""} min-h-screen flex flex-col bg-[color:var(--coh-paper)] text-[color:var(--coh-ink)]`}
    >
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
    </div>
  );
};
